import { useTranslations } from '@vocab/react';
import {
  Dialog,
  RadioGroup,
  RadioItem,
  Stack,
  TextLink,
  Text,
  Button,
  Inline,
} from 'braid-design-system';
import type { FormEvent } from 'react';

import translations from './.vocab';
interface ReportDialogProps {
  id: string;
  title: string;
  value: string;
  onChange: (event: FormEvent<HTMLInputElement>) => void;
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default ({
  id,
  title,
  value,
  onChange,
  open,
  onClose,
  onSubmit,
}: ReportDialogProps) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog id={id} title={title} open={open} onClose={onClose} width="small">
      <Text id="fieldLabel" tone="secondary">
        {t('dialogDescription')}
      </Text>
      <RadioGroup
        id="radio-dialog"
        aria-labelledby="fieldLabel"
        value={value}
        onChange={onChange}
      >
        <RadioItem label={t('offensive')} value={t('offensive')} />
        <RadioItem
          label={t('illegalOrFraudulent')}
          value={t('illegalOrFraudulent')}
        />
        <RadioItem label={t('sexualOrViolent')} value={t('sexualOrViolent')} />
        <RadioItem
          label={t('racialCommentary')}
          value={t('racialCommentary')}
        />
        <RadioItem
          label={t('drugRelatedReferences')}
          value={t('drugRelatedReferences')}
        />
        <RadioItem label={t('spam')} value={t('spam')} />
        <RadioItem
          label={t('commercialInNature')}
          value={t('commercialInNature')}
        />
      </RadioGroup>
      <Stack space="small">
        <Text tone="secondary">
          {t('notSureAboutReport')}
          {t('checkoutOur')}
        </Text>
        <Text tone="formAccent">
          <TextLink
            href="https://my.jobstreet.com/page/mc-community-guidelines"
            target="_blank"
            weight="weak"
            hitArea="large"
          >
            {t('communityGuidelines')}
          </TextLink>
        </Text>
      </Stack>
      <Inline space="small" align="left">
        <Button variant="ghost" tone="formAccent" onClick={onSubmit}>
          {t('report')}
        </Button>
        <Button variant="transparent" tone="formAccent" onClick={onClose}>
          {t('cancel')}
        </Button>
      </Inline>
    </Dialog>
  );
};
